import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
interface PanelProps {
  title?: ReactNode;
  hint?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}
export function Panel({
  title,
  hint,
  action,
  children,
  className,
  bodyClassName
}: PanelProps) {
  return <section className={twMerge('rounded-3xl border-[1.5px] border-line bg-surface shadow-card', className)} data-id="element-1281" data-mp="2kixgov6ofhpf">
      {(title || action) && <div className="flex items-start justify-between gap-3 px-4 pb-1 pt-4" data-id="element-1282" data-mp="2bjk6u1en4r46">
          <div className="min-w-0" data-id="element-1283" data-mp="2bln67c1onwlk">
            {title && <h2 className="font-display text-lg font-semibold leading-tight" data-id="element-1284" data-mp="1wvflsqs483i8">{title}</h2>}
            {hint && <p className="mt-0.5 text-xs text-muted" data-id="element-1285" data-mp="21szc4p2386qj">{hint}</p>}
          </div>
          {action}
        </div>}
      <div className={twMerge('px-4 pb-4 pt-2', bodyClassName)} data-id="element-1286" data-mp="1nvaqhf074vkf">{children}</div>
    </section>;
}
export function EmptyNote({
  children
}: {
  children: ReactNode;
}) {
  return <p className="rounded-2xl bg-canvas px-4 py-5 text-center text-sm font-semibold text-muted" data-id="element-1287" data-mp="2hcsll53nd0fl">{children}</p>;
}